/* ARQ JS */
var rewardsContainers = document.querySelectorAll('.rewards-container');

rewardsContainers.forEach(function(rewardsContainer) {
  var aElements = rewardsContainer.querySelectorAll('.rewards-heads-container > div');
  var bElements = rewardsContainer.querySelectorAll('.rewards-info-container > div');

  rewardsContainer.addEventListener('click', function(event) {
    var targetA = event.target.closest('.rewards-head');
    if (!targetA) return; // Exit if the clicked element is not a rewards-head

    var index = Array.prototype.indexOf.call(aElements, targetA);
    var targetB = bElements[index];

    if (targetA.classList.contains('is-selected')) {
      // Check if there is only one B element open
      var isOpen = rewardsContainer.querySelectorAll('.rewards-head.is-selected').length === 1;
      if (isOpen) {
        return; // Do not allow closing if it's the only open B element
      }
    } else {
      aElements.forEach(function(aElement) {
        aElement.setAttribute('aria-expanded', 'false');
        aElement.classList.remove('is-selected');
      });

      bElements.forEach(function(bElement) {
        bElement.classList.add('non-focused');
      });
    }

    targetA.setAttribute('aria-expanded', 'true');
    targetA.classList.add('is-selected');
    targetB.classList.remove('non-focused');
  });

  rewardsContainer.addEventListener('keydown', function(event) {
    var currentIndex = Array.prototype.indexOf.call(aElements, event.target);

    if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
      event.preventDefault();
      if (currentIndex < aElements.length - 1) {
        aElements[currentIndex + 1].focus();
      } else {
        aElements[0].focus();
      }
    } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (currentIndex > 0) {
        aElements[currentIndex - 1].focus();
      } else {
        aElements[aElements.length - 1].focus();
      }
    }
  });
});

/* ARQ JS END */